module.exports = __webpack_public_path__ + "img/fechar.398870a8.png";